import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import { reducer as formReducer } from 'redux-form'

import actionTypes from 'redux/actions/actionTypes'
import modalReducer from './modalReducer'
import centerInformationReducer from './centerInformationReducer'
import topInformationReducer from './topInformationReducer'
import alertReducer from './alertReducer'
import confirmReducer from './confirmReducer'
import shareReducer from './shareReducer'
import vendorsReducer from './vendorsReducer'
import signupReducer from './signupReducer'
import loginReducer from './loginReducer'
import userReducer from './userReducer'
import bindersReducer from './bindersReducer'
import lessonsReducer from './lessonsReducer'
import lessonsPickerReducer from './lessonsPickerReducer'
import cartReducer from './cartReducer'
import privateLibraryReducer from './privateLibraryReducer'
import onboardingReducer from './onboardingReducer'
import adminOnboardingReducer from './adminOnboardingReducer'
import foldersReducer from './foldersReducer/foldersReducer'
import myAccountReducer from './myAccountReducer'
import playgroundReducer from './playgroundReducer'
import themesReducer from './themesReducer'
import quizReducer from './quizReducer'
import matchingPairsCtReducer from './matching_pairs_ct_reducer'
import storeFrontReducer from './storeFrontReducer'
import previewReducer from './previewReducer'
import drawItReducer from './drawItReducer'
import uiReducer from './uiReducer'
import processingReducer from './processingReducer'
import pollReducer from './pollReducer'
import oeqReducer from './oeqReducer'
import desmosReducer from './desmosReducer'
import flocabularyReducer from './flocabularyReducer'
import overlayReducer from './overlayReducer'
import myLibraryReducer from './myLibraryReducer'
import ltiReducer from './ltiReducer'
import storeReducer from './storeReducer'
import myLibraryPreviewReducer from './myLibraryPreviewReducer'
import loadingReducer from './loadingReducer'
import studentReducer from './studentReducer'
import qsReducer from './qsReducer'
import dmStorageExperimentReducer from './dmStorageExperimentReducer'
import gameReducer from './gameReducer'
import externalReducer from './externalReducer'
import onboardingActivityReducer from './onboardingActivityReducer'
import interactiveVideoReducer from './interactiveVideoReducer'
import assetsReducer from './assetsReducer'
import navigationMenuReducer from './navigationMenuReducer'
import collaborateReducer from './collaborateReducer'
import flipgridReducer from './flipgridReducer'
import interactiveVideoCreationReducer from './interactiveVideoCreationReducer'
import fillInTheBlanksSessionReducer from './fillInTheBlanks/sessionReducer'
import mediaSlidesReducer from './mediaSlidesReducer'
import creationToolReducer from './creationTool'
import lessonSessionReducer from './lessonSessionReducer'
import activitiesReducer from './activitiesReducer'
import onboardingGuideReducer from './onboardingGuideReducer'
import teacherReducer from './teacherReducer'
import slidesReducer from './slidesReducer'
import whiteboardSessionReducer from './whiteboardSessionReducer'

const form = formReducer.plugin({
	Login: (state, action) => {
		const newState = {...state}
		switch (action.type) {
			case actionTypes.LOGIN_RESET_AUTHENTICATION:
				newState.fields = {...state.fields}
				newState.fields.email = {
					...state.fields.email,
					...{touched: false},
				}
				newState.fields.password = {
					...state.fields.password,
					...{touched: false},
				}
				return newState
			default:
				return state
		}
	},
})

const rootReducer = combineReducers({
	routing: routerReducer,
	modal: modalReducer,
	centerInformation: centerInformationReducer,
	topInformation: topInformationReducer,
	alert: alertReducer,
	confirm: confirmReducer,
	share: shareReducer,
	vendors: vendorsReducer,
	onboarding: onboardingReducer,
	adminOnboarding: adminOnboardingReducer,
	onboardingActivity: onboardingActivityReducer,
	dmStorageExperiment: dmStorageExperimentReducer,
	form,
	signup: signupReducer,
	login: loginReducer,
	user: userReducer,
	binders: bindersReducer,
	lessons: lessonsReducer,
	lessonsPicker: lessonsPickerReducer,
	cart: cartReducer,
	libraries: privateLibraryReducer,
	folders: foldersReducer,
	myAccount: myAccountReducer,
	playground: playgroundReducer,
	themes: themesReducer,
	quiz: quizReducer,
	matchingPairsCt: matchingPairsCtReducer,
	preview: previewReducer,
	storefront: storeFrontReducer,
	drawIt: drawItReducer,
	ui: uiReducer,
	processing: processingReducer,
	poll: pollReducer,
	oeq: oeqReducer,
	desmos: desmosReducer,
	overlay: overlayReducer,
	myLibrary: myLibraryReducer,
	myLibraryPreview: myLibraryPreviewReducer,
	lti: ltiReducer,
	loading: loadingReducer,
	store: storeReducer,
	student: studentReducer,
	qs: qsReducer,
	game: gameReducer,
	flocabulary: flocabularyReducer,
	external: externalReducer,
	interactiveVideo: interactiveVideoReducer,
	assets: assetsReducer,
	navigationMenu: navigationMenuReducer,
	collaborate: collaborateReducer,
	flipgrid: flipgridReducer,
	interactiveVideoCreation: interactiveVideoCreationReducer,
	fillInTheBlanksSession: fillInTheBlanksSessionReducer,
	mediaSlides: mediaSlidesReducer,
	creationTool: creationToolReducer,
	lessonSession: lessonSessionReducer,
	activities: activitiesReducer,
	onboardingGuide: onboardingGuideReducer,
	teacher: teacherReducer,
	slides: slidesReducer,
	whiteboardSession: whiteboardSessionReducer,
})

export default rootReducer
